/**
 * Multa e juros do atraso (`PG-06`, ADR-093) na tela da Administração: a pessoa digita em
 * **percentual** ("2" ou "2,5"), e a API guarda em **pontos-base** (centésimos de ponto
 * percentual: 2% = 200). Os tetos são os do domínio (`transit_domain.extemporanea`), que o
 * banco repete — a tela só os adianta, para não deixar a pessoa descobrir no 422.
 */

/** 10% de multa, uma vez. */
export const MULTA_MAXIMA_BP = 1000;
/** 5% de juros ao mês. */
export const JUROS_MAXIMOS_AO_MES_BP = 500;

/** "2,5" → 250; vazio é zero. `null` quando não é um percentual de até duas casas. */
export function percentualEmBp(texto: string): number | null {
  const limpo = texto.trim().replace(",", ".");
  if (limpo === "") return 0;
  if (!/^\d{1,3}(\.\d{1,2})?$/.test(limpo)) return null;
  return Math.round(Number(limpo) * 100);
}

/** 250 → "2,5"; zero é "0". */
export function bpEmPercentual(bp: number): string {
  const inteiro = Math.trunc(bp / 100);
  const centesimos = bp % 100;
  if (centesimos === 0) return String(inteiro);
  return `${inteiro},${String(centesimos).padStart(2, "0").replace(/0$/, "")}`;
}
